import ko from "knockout";
import manifestManager from "flow/utils/manifestManager";
import $ from "jquery";
import hashQuery from "flow/utils/hashQuery";
import metaCache from "flow/utils/metaCache";
import config from "flow/config";

export interface IBreadcrumb {
    title: string;
    id: string;
}

function singletonInstance() {
    const homeFragment = ko.observable<string>("");
    const functionId = ko.observable<string>("");
    const contextFunctions = ko.observableArray<string>([]);

    function setHomeLevel(fragment: string) {
        homeFragment(fragment);
        functionId("");
        contextFunctions.removeAll();
    }

    function updateHomeLevel(fragment: string) {
        homeFragment(fragment);
    }

    function setFunctionLevel(fragment: string) {
        functionId(fragment);
        contextFunctions.removeAll();
    }

    //addContextLevel is responsible of manipulating the list of breadcrumbs on a context level
    function addContextLevel(fragment: string) {
        //Retrieve the context id of the crumb (fragment) being added
        const contextId = hashQuery.getContextId(fragment);

        //Try to get an existing crumb that has the same context id as the crumb (fragment) being added
        const matchingItem = $.grep(contextFunctions(), function (item) {
            const candidateContextId = hashQuery.getContextId(item);
            return candidateContextId === contextId;
        });

        if (matchingItem.length == 0) {
            //If a matching crumb with the same context id wasn't found,
            //add the new crumb (fragment) to the end of the list
            contextFunctions.push(fragment);
            return;
        } else if (contextFunctions()[contextFunctions().length - 1] === matchingItem[0]) {
            //If a matching crumb with the same context id is the last,
            //remove the last crumb, and
            //add the new crumb (fragment) to the end of the list
            contextFunctions.pop();
            contextFunctions.push(fragment);
            return;
        } else {
            //
            for (let i = contextFunctions().length - 1; i >= 0; i--) {
                //If a matching crumb with the same context id is not the last,
                //remove the matching crumb and its child crumbs, and
                //add the new crumb (fragment) to the end of the list
                if (contextFunctions()[i] !== matchingItem[0]) {
                    contextFunctions.pop();
                } else {
                    contextFunctions.pop();
                    contextFunctions.push(fragment);
                    return;
                }
            }
        }
    }

    function back() {
        if (contextFunctions().length > 1) {
            contextFunctions.pop();
            return contextFunctions()[contextFunctions().length - 1];
        }

        if (contextFunctions().length == 1) {
            contextFunctions.removeAll();

            if (!!functionId()) {
                return functionId();
            }
        }

        return homeFragment();
    }

    const breadcrumbs = ko.pureComputed<IBreadcrumb[]>(() => {
        const items: IBreadcrumb[] = [
            {
                title: metaCache.lookup(config.metaKeys.home, config.metaKeys.home),
                id: homeFragment() || config.componentIds.homeContext
            }
        ];
        let manifest;

        if (!!functionId()) {
            const viewModelId = hashQuery.getViewModelId(functionId());
            manifest = manifestManager.getManifestWithId(viewModelId);
            items.push({ title: manifest.name, id: manifest.id });
        }

        contextFunctions().forEach(item => {
            manifest = manifestManager.getManifestWithId(hashQuery.getContextId(item));
            const title = manifest.name == undefined || manifest.name == null ? manifest.id : manifest.name;
            items.push({ title: title, id: item });
        });

        return items;
    });

    const currentBreadcrumbTitle = ko.pureComputed<string>(function () {
        return breadcrumbs()[breadcrumbs().length - 1].title;
    });

    function cleanHistory(id?: string) {
        if (!functionId().startsWith("/" + id)) {
            functionId("");
        }

        contextFunctions.remove(function (item: string) {
            const cleanedId = hashQuery.getContextId(item);
            return cleanedId !== id;
        });
    }

    function updateCurrentFragment(newFragment: string) {
        if (contextFunctions().length > 0) {
            const index = contextFunctions().length - 1;
            contextFunctions.splice(index, 1, newFragment);
        } else if (!!functionId()) {
            functionId(newFragment);
        } else {
            homeFragment(newFragment);
        }
    }

    return {
        setHomeLevel,
        updateHomeLevel,
        setFunctionLevel,
        addContextLevel,
        breadcrumbs,
        currentBreadcrumbTitle,
        back,
        cleanHistory,
        updateCurrentFragment
    };
}
export default singletonInstance();
